module.exports = __webpack_public_path__ + "static/assets/047aafa0958002d63551e63d1547c5a2.svg";